import {
  getMissingAddressFields,
  type AddressValidationField,
} from '@/tenants/_shared/lib/address-validation';

export type RegistrationShippingField = AddressValidationField;

export interface RegistrationShippingValidationInput {
  requiresShipping: boolean;
  streetAddress: string;
  city: string;
  state?: string;
  postalCode: string;
  country: string;
  stateRequired?: boolean;
}

export function getMissingRegistrationShippingFields(
  input: RegistrationShippingValidationInput,
): RegistrationShippingField[] {
  return getMissingAddressFields({
    required: input.requiresShipping,
    streetAddress: input.streetAddress,
    city: input.city,
    state: input.state,
    postalCode: input.postalCode,
    country: input.country,
    stateRequired: input.stateRequired,
  });
}
